import qs from 'qs'
import axios from '../index'
/**
 * @description 判断是否绑定微信账号
 * @author lu
 * @data 2019-04-15
 * @export
 */
export function getUnbindall (params) {
  return axios.post('/user/wechat-is-bind', qs.stringify(params))
}

/**
 * @description 解绑定微信账号
 * @author lu
 * @data 2019-04-25
 * @export
 * @param {*} params
 * @returns
 */
export function getBind (params) {
  return axios.post('/user/wechat-untying', qs.stringify(params))
}
